import React from 'react';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { ArrowForward as ContinueIcon } from '@mui/icons-material';

export type LaneActionLink = {
  label: string;
  path: string;
};

type LanePrimaryActionCardProps = {
  eyebrow?: string;
  title: string;
  detail: string;
  ctaLabel: string;
  ctaPath: string;
  tone?: 'primary' | 'warning' | 'success';
  onNavigate: (path: string) => void;
  statusLine?: string;
  secondaryActions?: LaneActionLink[];
};

export function LanePrimaryActionCard({
  eyebrow = 'Next required action',
  title,
  detail,
  ctaLabel,
  ctaPath,
  tone = 'primary',
  onNavigate,
  statusLine,
  secondaryActions = [],
}: LanePrimaryActionCardProps) {
  const buttonColor = tone === 'warning' ? 'warning' : tone === 'success' ? 'success' : 'primary';

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={1.5}>
          <Box>
            <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: '0.08em' }}>
              {eyebrow}
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 700, mt: 0.5, mb: 0.75 }}>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {detail}
            </Typography>
          </Box>

          {statusLine ? (
            <Typography variant="caption" color="text.secondary">
              {statusLine}
            </Typography>
          ) : null}

          <Button
            fullWidth
            variant="contained"
            color={buttonColor}
            endIcon={<ContinueIcon />}
            onClick={() => onNavigate(ctaPath)}
          >
            {ctaLabel}
          </Button>

          {secondaryActions.length > 0 ? (
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              {secondaryActions.map((action) => (
                <Button
                  key={`${action.path}-${action.label}`}
                  size="small"
                  variant="outlined"
                  onClick={() => onNavigate(action.path)}
                >
                  {action.label}
                </Button>
              ))}
            </Stack>
          ) : null}
        </Stack>
      </CardContent>
    </Card>
  );
}
